import actionTypes from '../../../redux/actionTypes'

export const setPageMetaTags = (pageMetaTags) => ({
  type: actionTypes.SET_PAGE_META_TAGS,
  payload: pageMetaTags
})
